'use strict';

var _ = require('lodash');
function DataRetrieverDateMergerService() {
  function merge(rules, toMergeFields) {
    return _.reduce(toMergeFields, function (mergedRules, toMergeFieldType) {
      return mergeDates(toMergeFieldType, _.cloneDeep(mergedRules));
    }, rules);
  }
  function mergeDates(toMergeFieldType, currentRules) {
    var dateFields = getRules(currentRules, toMergeFieldType);
    if (_.isEmpty(dateFields)) {
      return currentRules;
    }
    var templateField = _.cloneDeep(_.first(dateFields));
    var dateRules = createDateClusters(dateFields, templateField);
    return currentRules.concat(dateRules);
  }
  function createDateClusters(toMergeRules, templateField) {
    var clusters = [];
    _.each(toMergeRules, function (rule) {
      var cluster = isOnCluster(rule, clusters);
      if (!cluster) {
        createCluster(clusters, rule);
      } else {
        expandCluster(cluster, rule);
      }
    });
    return _.transform(clusters, function (clusterRules, cluster) {
      var rule = _.cloneDeep(templateField);
      rule.leftOperand = cluster.beginEdge.clone();
      rule.rightOperand = cluster.endEdge.clone();
      rule.operator = 'Between';
      clusterRules.push(rule);
      return clusterRules;
    }, []);
  }
  function expandCluster(cluster, rule) {
    cluster.beginEdge = rule.leftOperand.valueOf() < cluster.beginEdge.valueOf() ? rule.leftOperand.clone() : cluster.beginEdge;
    cluster.endEdge = getEndEdge(rule).valueOf() > cluster.endEdge.valueOf() ? getEndEdge(rule).clone() : cluster.endEdge;
  }
  function createCluster(clusters, rule) {
    clusters.push({
      beginEdge: rule.leftOperand.clone(),
      endEdge: getEndEdge(rule)
    });
  }
  function getEndEdge(rule) {
    return rule.rightOperand ? rule.rightOperand.clone() : rule.leftOperand.clone();
  }
  function isOnCluster(rule, clusters) {
    return _.find(clusters, function (cluster) {
      var startDate = cluster.beginEdge.clone().startOf('d').subtract(1, 'd').valueOf();
      var endDate = cluster.endEdge.clone().endOf('d').add(1, 'd').valueOf();
      return endDate >= rule.leftOperand.valueOf() && startDate <= getEndEdge(rule).valueOf();
    });
  }
  function getRules(currentRules, toMergeFieldType) {
    return _.chain(currentRules).remove(function (rule) {
      return _.matches(toMergeFieldType)(rule) && _.includes(['=', 'between'], rule.operator);
    }).sortBy(function (field) {
      return field.leftOperand.valueOf();
    }).value();
  }
  return {
    merge: merge
  };
}
DataRetrieverDateMergerService.$inject = [];
module.exports = DataRetrieverDateMergerService;